import React from 'react';

const AboutUsCard = ({
  title,
  description,
  index,
}: {
  title: string;
  description: string;
  index: number;
}) => {
  const borderStyle = (index: number) => {
    switch (index) {
      case 1:
        return 'md:border-b md:border-r md:border-text/50'; // bottom + right
      case 2:
        return 'md:border-b md:border-l md:border-text/50'; // bottom + left
      case 3:
        return 'md:border-t md:border-r md:border-text/50'; // top + right
      case 4:
        return 'md:border-t md:border-l md:border-text/50'; // top + left
      default:
        return '';
    }
  };

  return (
    <section
      className={`p-6 lg:p-8 max-h-96   bg-background space-y-2 max-md:border-b max-md:border-text/50 border-dashed ${borderStyle(
        index
      )}`}
    >
      <h1 className="text-2xl lg:text-4xl  text-center md:text-left section-title text-primary " style={{ fontSize: "36px"}}>{title}</h1>
      <p className=" text-light-text text-center md:text-left md:w-[85%] ">{description}</p>
    </section>
  );
};

export default AboutUsCard;
